import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import { Dialog, DialogContent, Theme, Typography } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useAppDispatch } from "@/Redux/Redux";
import WebsiteLoginForm from "@/Domains/AuthenticationManagement/WebsiteLoginForm";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface LoginExpiredModalProps {}

const useStyles = makeStyles()((theme: Theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
    },

    wrapper: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        position: "relative",
    },

    appBar: {
        position: "relative",
        boxShadow: "none",
    },

    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },

    toolbar: {
        height: 94,
    },
}));

const LoginExpiredModal: FunctionComponent<
    LoginExpiredModalProps
> = ({}): JSX.Element => {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    return (
        <Dialog
            onClose={() => {}}
            aria-labelledby="customized-dialog-title"
            open={true}
            fullScreen={true}
            maxWidth={"xs"}
        >
            <DialogContent style={{ textAlign: "center" }}>
                <ReportProblemOutlinedIcon
                    style={{ fontSize: 100, color: "red" }}
                />
                <Typography gutterBottom>
                    {t("login.messages.loginExpired")} <br />
                    {t("login.messages.tryToLoginAgain")}
                </Typography>
                <WebsiteLoginForm />
            </DialogContent>
        </Dialog>
    );
};

export default LoginExpiredModal;
